import { Action } from "..";
import { ServiceBase } from "../../types/serviceBase";

export const SERVICE_CHANGE = "SERVICE_CHANGE";

export function setService(service: ServiceBase): Action {
  return { type: SERVICE_CHANGE, payload: service };
}
